import Constant from '../../const';
const axios = require('axios');

const getCountUnsolvedPCare = async params => {
  try {
    const response = await axios.get(
      Constant.apiUrl.concat('/pcare/report/failed-count'),
      {
        params,
      },
    );
    return response;
  } catch (error) {
    const err = error;
    throw err;
  }
};

export default getCountUnsolvedPCare;
